(function ($) {
    const btnShowMore = $('[data-action="show-more"]');
    const nbShow = 6;
    let activeCat = 'all';

    function getHiddenArticles() {
        if (activeCat === 'all') {
            return $('.block-nouvelles__container .article--hidden');
        }
        return $('.block-nouvelles__container .article--hidden').filter(function () {
            const cats = $(this).data('cat').split(',');
            return cats.map(c => c.trim()).includes(activeCat);
        });
    }

    function updateShowMoreButton() {
        btnShowMore.toggle(getHiddenArticles().length > 0);
    }

    function showMore() {
        const articles = getHiddenArticles();
        articles.slice(0, nbShow).hide().removeClass('article--hidden').fadeIn(500);
        updateShowMoreButton();
    }

    function hideAllArticles() {
        $('.block-nouvelles__container .article').fadeOut(0).addClass('article--hidden');
    }

    function filterCategory() {
        hideAllArticles();
        $('.block-nouvelles__categories button').removeClass('active');
        $(this).addClass('active');
        activeCat = $(this).data('slug');
        showMore();

        // Update url
        const url = new URL(window.location);
        if (activeCat === 'all') {
            url.searchParams.delete('cat');
        } else {
            url.searchParams.set('cat', activeCat);
        }
        window.history.pushState({}, '', url);
    }

    btnShowMore.on('click', showMore);
    $('.block-nouvelles__categories button').on('click', filterCategory);

    // Cliquer sur la catégorie active - Initialisation au chargement
    setTimeout(() => {
        $('.block-nouvelles__categories button.active').trigger('click');
    }, 15);

    updateShowMoreButton(); // état initial correct au chargement
}(jQuery));
